<template>
  <div class="max-md:max-w-[360px] max-md:px-5 max-md:mx-auto">
    <button class="absolute top-4 md:top-[30px] ltr:left-5 ltr:md:left-8 rtl:right-5 rtl:md:right-8" @click="goBack" :disabled="disableBackButton">
      <icon-chevron-mini 
        class="text-[20px] rtl:rotate-180"
        :class="disableBackButton? 'text-[#d9d9d9]' : 'text-[#8c8c8c]'"
      />
    </button>
    <NuxtImg loading="lazy"
      :src="config.public.header.logo"
      width="150px"
      class="w-auto object-contain mb-10 md:mb-8"
      :class="
        config.public.header.logoHeightSize
          ? config.public.header.logoHeightSize
          : 'h-9'
      "
    />
    <h3
      v-if="title.length"
      class="mb-8 md:mb-5 text-primary-1 text-mobile-heading-3 md:text-heading-3"
    >
      {{ title }}
    </h3>
    <slot />
  </div>
</template>

<script setup>
const config = useRuntimeConfig();
const emit = defineEmits(['go-back'])

defineProps({
    title: {
        type: String,
        default: '',
    },
    disableBackButton: { type: Boolean, default: false}
});

const goBack = () => {
  emit('go-back')
}
</script>